<template-comment>
<!--
component: 
components\mobile-app-install-managed-google-play\mobile-app-install-managed-google-play.component
-->
</template-comment>

<app-dmp-commons></app-dmp-commons>

<ng-container *ngIf="! dmpCommons.isAuthenticated()">
    Not authenticated! <a routerLink="/sign-in">Sign In</a>
    <amplify-authenticator></amplify-authenticator>
</ng-container>

<ng-container *ngIf="dmpCommons.isAuthenticated()">
  
  <div class="desktop-mode-script">
    <script>
      // This script ensures the page behaves like a desktop site on mobile
      (function() {
        var viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.content = 'width=1024, initial-scale=1.0, maximum-scale=3.0';
        } else {
          var meta = document.createElement('meta');
          meta.name = 'viewport';
          meta.content = 'width=1024, initial-scale=1.0, maximum-scale=3.0';
          document.getElementsByTagName('head')[0].appendChild(meta);
        }
      })();
    </script>
  </div>

  <p-toolbar [ngStyle]="{display: messagesVisibility}">
      <p-messages key="permanentMessages"></p-messages>
      <p-toast key="shortMessages"></p-toast>
  </p-toolbar>

  <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
              <div class="table-title">
                  Managed Google Play Store
                  &nbsp; &nbsp; &nbsp;
              </div>
          </div>
  </ng-template>

  <div class="managed-google-play-div-container">
    <div #googlePlayContainer id="googlePlayContainer" class="managed-google-play-iframe-container"></div>
  </div>

</ng-container>